import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FaefStateService } from './../faef-state.service';
export class VendasMargemComponent {
    constructor(fb, state) {
        this.fb = fb;
        this.state = state;
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
        this.editing = -1;
    }
    ngOnInit() {
        this.createForms();
        const faef = this.state.getLast();
        this.mercadorias = faef.faefComercio || [];
        if (faef.faefVendas) {
            this.vendaForm.patchValue(faef.faefVendas, { emitEvent: false });
        }
    }
    createForms() {
        this.vendaForm = this.fb.group({
            faefPrazoCliente: ['', Validators.required],
            valorADoisMeses: ['', Validators.required],
            valorATresMeses: ['', Validators.required],
            valorAUmMes: ['', Validators.required]
        });
        this.mercadoriaForm = this.fb.group({
            nomeMercadoria: ['', Validators.required],
            precoUnitarioCompra: ['', Validators.required],
            precoUnitarioVenda: ['', Validators.required],
            quantidadeEstoque: ['', Validators.required],
            quantidadeVendida: ['', Validators.required]
        });
    }
    updateState() {
        const faef = this.state.getLast();
        const { faefPrazoCliente, valorADoisMeses, valorATresMeses, valorAUmMes } = this.vendaForm.value;
        faef.faefVendas = {
            faefPrazoCliente: Number(faefPrazoCliente),
            valorADoisMeses: Number(valorADoisMeses),
            valorATresMeses: Number(valorATresMeses),
            valorAUmMes: Number(valorAUmMes)
        };
        faef.faefComercio = this.mercadorias.map(m => (Object.assign({}, m, { precoUnitarioCompra: Number(m.precoUnitarioCompra), precoUnitarioVenda: Number(m.precoUnitarioVenda), quantidadeEstoque: Number(m.quantidadeEstoque), quantidadeVendida: Number(m.quantidadeVendida) })));
        this.state.setState(faef);
    }
    onClickNext() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.updateState();
            this.next.emit();
        });
    }
    onClickPrevious() {
        this.updateState();
        this.previous.emit();
    }
    addMercadoria() {
        if (this.editing < 0) {
            this.mercadorias.push(this.mercadoriaForm.value);
        }
        else {
            this.mercadorias[this.editing] = this.mercadoriaForm.value;
        }
        this.mercadoriaForm.reset();
        this.editing = -1;
    }
    onMercadoriaEdit(index) {
        this.editing = index;
        this.mercadoriaForm.setValue(this.mercadorias[index]);
    }
    onMercadoriaRemove(index) {
        this.mercadoriaForm.reset();
        this.editing = -1;
        this.mercadorias = this.mercadorias.filter(m => m !== this.mercadorias[index]);
    }
    cancelar() {
        this.mercadoriaForm.reset();
        this.editing = -1;
    }
}
